export default __webpack_public_path__ + "static/house_b.c086be4fee8172d1bfc0de78dc8267bf.svg";